import MediaAPIService from "../media_api_service";
import apiUtils from "../../../../core/utils/api_utils";


export default class MediaAPIServiceImpl extends MediaAPIService {
    static #instance = null;

    constructor() {
        if (MediaAPIServiceImpl.#instance) {
            return MediaAPIServiceImpl.#instance; // Return existing instance instead of creating a new one
        }
        super(); // Call parent constructor
        MediaAPIServiceImpl.#instance = this; // Store instance
    }

    async getChatImages({ skip, limit, chatChannelId }) {
        try {
            const response = await apiUtils.get(`/api/chat/media-files?skip=${skip}&limit=${limit}&chatChannelId=${chatChannelId}`);
            return response.data;
        } catch (err) {
            console.log(err);
            return err.response ? err.response.data : { success: false, message: "Something went wrong", data: [] };
        }
    }
}